<template>
    <div>
      <VueMultiselect
        v-model="taggingSelectedAux"
        :options="taggingOptions"
        :multiple="true"
        :taggable="true"
        @tag="addTag"
        tag-placeholder="Add this as new tag"
        placeholder="Selecione os cursos"
        label="name"
        track-by="code"
        max="8"
      />
    </div>
  </template>
  
  <script>
  import VueMultiselect from 'vue-multiselect'
  
  export default {
    components: { VueMultiselect },
    props: {
      taggingOptions: [],
    },
    data () {
      return {
        selected: null,
        options: ['list', 'of', 'options'],
        taggingSelectedAux: []
      }
    },
    watch: {
      taggingSelectedAux: {
        handler(newVal) {
          this.$emit('taggingSelectedAuxChanged', this.taggingSelectedAux);
        },
        deep: true
      }
    },
    methods: {
      addTag (newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
        }
        this.taggingOptions.push(tag)
        this.taggingSelected.push(tag)
      }
    }
  }
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.css"></style>
  